module.exports = __webpack_public_path__ + "static/media/wizualizacja-120.f9573e2e.png";